@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.alert {
  margin-bottom: 20px;
}

.container {
  display: flex;
  flex-direction: column;
}

.helperText {
  color: var(--text-soft);
  margin-top: 20px;
  @include typography-v2-body-xs;
}

.cardDetails {
  display: flex;
  padding: 8px 12px;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--border-default);
  @include border-radius-r1;
  color: var(--text-disabled);
}

.leftPart {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rightPart {
  display: flex;
  gap: 20px;
}

.alertTitle {
  @include typography-v2-title-sm;
}

.label {
  display: inline-flex;
  @include typography-v2-body-sm;
  margin-bottom: 4px;
}
